import React, { Component } from 'react'
import { NavLink } from 'react-router-dom'
import { post, get } from '../../../../utils/networking'
import StarRatings from 'react-star-ratings'
import { ScaleLoader } from 'react-spinners'
import RatingReadOnly from 'react-rating'
import moment from 'moment'
import './style.css'
export default class MyStore extends Component {

    constructor(props) {
        super(props)

        this.state = {
            myStore: [],
            isLoaded: false,
            isProcessing: false,
        }

    }

    componentDidMount() {
        get('store/get', "customer", result => {
            this.setState({
                myStore: result,
                isLoaded: true
            })
        }, errors => {
            this.setState({
                isLoaded: true
            })
        })
    }

    handleSetDefaultStore(id) {
        this.setState({
            isProcessing: true
        })
        let param = {
            storeId: id
        }
        post("user/updateDefaultStore", param, "customer", result => {
            get('store/get', "customer", result => {
                this.setState({
                    myStore: result,
                    isLoaded: true,
                    isProcessing: false
                })
            })
        })
    }

    render() {

        let {
            myStore,
            isLoaded,
            isProcessing
        } = this.state;

        return (
            <div>
                <div className="box box-primary my-store">
                    {
                        (isLoaded) ? <div className="top-spa">
                            <div className="top-spa-detail">
                                {
                                    (myStore.length > 0) ? myStore.map((spa, i) =>
                                        i < 1 && <div className="top-spa-item" key={i}>
                                            <div className="item-detail">
                                                {
                                                    (i == 0) ? <div className="default-store">
                                                        <span>My Nails Salon</span>
                                                    </div> : <div className="set-default">
                                                            <span onClick={() => this.handleSetDefaultStore(spa.id)}>{(isProcessing) ? "Wating..." : "Set to My Prefer Nails Salon"}</span>
                                                        </div>
                                                }

                                                <NavLink to={"/spa/" + ((spa.slug) ? spa.slug : "")} ><div className="detail-left-image" style={{ background: "url(" + ((spa.photo) ? ("http://pos.nailspaofamerica.com/ClientWeb/FileUpload/" + spa.photo.imageURL) : "http://binhphuoc.gov.vn/themes/default/images/businesslistings/noimages.png") + ")" }} ></div></NavLink>
                                                <div className="detail-right">
                                                    <NavLink to={"/spa/" + spa.slug} ><span className="spa-name">{spa.name}</span></NavLink>
                                                    <div className="rating-review">
                                                        <StarRatings
                                                            rating={spa.rate}
                                                            starRatedColor="#935ed6"
                                                            numberOfStars={5}
                                                            starSpacing="9px"
                                                            starEmptyColor="#e3ceff"
                                                        />
                                                        <span className="review-count">{spa.reviews} Reviews</span>
                                                    </div>
                                                    <span className="spa-address">{spa.address1}</span>
                                                    {
                                                        (spa.latestReview) ? <div className="lastest-review">
                                                            <div className="left">
                                                                <span className="name">Review by:<br />{(spa.latestReview) ? spa.latestReview.reviewerName : ""}</span>
                                                            </div>
                                                            <div className="right">
                                                                <span className="title">{(spa.latestReview) ? spa.latestReview.title : ""}</span>
                                                                <RatingReadOnly
                                                                    color="red"
                                                                    initialRating={(spa.latestReview) ? spa.latestReview.overallRating : ""}
                                                                    emptySymbol={<img src={require('../../../../assets/images/star_empty.png')} className="icon" style={{ width: "15px", marginRight: "2px" }} />}
                                                                    fullSymbol={<img src={require('../../../../assets/images/star.png')} className="icon" style={{ width: "15px", marginRight: "2px" }} />}
                                                                    readonly
                                                                />
                                                                <span className="decription">{(spa.latestReview) ? spa.latestReview.description.substring(0, 200) : ""}</span>
                                                                <span className="see-more"><NavLink exact to={"/spa/" + ((spa.slug) ? spa.slug : "")}>Read more...</NavLink></span>
                                                            </div>
                                                        </div> : <div className="lastest-review">
                                                                <div className="left">
                                                                    <span className="name">No review</span>
                                                                </div>
                                                                <div className="right">
                                                                </div>
                                                            </div>
                                                    }

                                                </div>
                                            </div>
                                        </div>
                                    ) : <div className="store-empty">
                                            <span>You have not used the service of any store.</span>
                                            <NavLink to="/spa?keyword=&location=">Boook appointment now</NavLink>
                                        </div>
                                }
                            </div>
                            <label className="other-nail-spa">Other Nails Salon</label>
                            <div className="top-spa-detail">
                                {
                                    (myStore.length > 0) ? myStore.map((spa, i) =>
                                        i > 0 && <div className="top-spa-item" key={i}>
                                            <div className="item-detail">
                                                {
                                                    (i == 0) ? <div className="default-store">
                                                        <span>My Nails Salon</span>
                                                    </div> : <div className="set-default">
                                                            <span onClick={() => this.handleSetDefaultStore(spa.id)}>{(isProcessing) ? "Wating..." : "Set to My Prefer Nails Salon"}</span>
                                                        </div>
                                                }

                                                <NavLink to={"/spa/" + ((spa.slug) ? spa.slug : "")} ><div className="detail-left-image" style={{ background: "url(" + ((spa.photo) ? ("http://pos.nailspaofamerica.com/ClientWeb/FileUpload/" + spa.photo.imageURL) : "http://binhphuoc.gov.vn/themes/default/images/businesslistings/noimages.png") + ")" }} ></div></NavLink>
                                                <div className="detail-right">
                                                    <NavLink to={"/spa/" + spa.slug} ><span className="spa-name">{spa.name}</span></NavLink>
                                                    <div className="rating-review">
                                                        <StarRatings
                                                            rating={spa.rate}
                                                            starRatedColor="#935ed6"
                                                            numberOfStars={5}
                                                            starSpacing="9px"
                                                            starEmptyColor="#e3ceff"
                                                        />
                                                        <span className="review-count">{spa.reviews} Reviews</span>
                                                    </div>
                                                    <span className="spa-address">{spa.address1}</span>
                                                    {
                                                        (spa.latestReview) ? <div className="lastest-review">
                                                            <div className="left">
                                                                <span className="name">Review by:<br />{(spa.latestReview) ? spa.latestReview.reviewerName : ""}</span>
                                                            </div>
                                                            <div className="right">
                                                                <span className="title">{(spa.latestReview) ? spa.latestReview.title : ""}</span>
                                                                <RatingReadOnly
                                                                    color="red"
                                                                    initialRating={(spa.latestReview) ? spa.latestReview.overallRating : ""}
                                                                    emptySymbol={<img src={require('../../../../assets/images/star_empty.png')} className="icon" style={{ width: "15px", marginRight: "2px" }} />}
                                                                    fullSymbol={<img src={require('../../../../assets/images/star.png')} className="icon" style={{ width: "15px", marginRight: "2px" }} />}
                                                                    readonly
                                                                />
                                                                <span className="decription">{(spa.latestReview) ? spa.latestReview.description.substring(0, 200) : ""}</span>
                                                                <span className="see-more"><NavLink exact to={"/spa/" + ((spa.slug) ? spa.slug : "")}>Read more...</NavLink></span>
                                                            </div>
                                                        </div> : <div className="lastest-review">
                                                                <div className="left">
                                                                    <span className="name">No review</span>
                                                                </div>
                                                                <div className="right">
                                                                </div>
                                                            </div>
                                                    }

                                                </div>
                                            </div>
                                        </div>
                                    ) : <div className="store-empty">
                                            <span>You have not used the service of any store.</span>
                                            <NavLink to="/spa?keyword=&location=">Boook appointment now</NavLink>
                                        </div>
                                }
                            </div>
                        </div> : <div>
                                <div className="spinner">
                                    <div className="rect1"></div>
                                    <div className="rect2"></div>
                                    <div className="rect3"></div>
                                    <div className="rect4"></div>
                                    <div className="rect5"></div>
                                </div>
                            </div>
                    }
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/user/overview/myStore/index.js